import axios, {AxiosError, AxiosResponse} from 'axios'
import {clearSessionAndRedirectToLogin} from './AuthHelpers'

const API_URL = process.env.REACT_APP_API_URL
const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null

const formDataAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'PUT, POST, PATCH, DELETE, OPTIONS',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Headers': '*',
  },
})

formDataAxios.interceptors.request.use((config) => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    const headers = config.headers as Record<string, unknown> | undefined
    if (headers) {
      delete headers['Content-Type']
      delete headers['content-type']
      ;['common', 'post', 'put', 'patch'].forEach((key) => {
        const group = headers[key] as Record<string, unknown> | undefined
        if (group && typeof group === 'object') {
          delete group['Content-Type']
          delete group['content-type']
        }
      })
    }
  }
  return config
})

formDataAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      clearSessionAndRedirectToLogin()
    }

    return Promise.reject(error)
  }
)

if (token) {
  formDataAxios.defaults.headers.common = {Authorization: `bearer ${token}`}
}

export default formDataAxios
